<div class="p-2 bg-gray-50 min-h-screen">
  <!-- PAGE HEADER -->
  <div class="flex flex-wrap justify-between items-center gap-3 mb-4">
    <div>
      <h3 class="text-lg font-semibold text-gray-800">{{ 'MONITORING.TITLE' | translate }}</h3>

      <p class="text-sm text-gray-500 mt-1">
        {{ 'MONITORING.LIST_SUBTITLE' | translate }}
      </p>
    </div>
  </div>

  @if (loading) {
    <div class="text-sm text-gray-500 mb-2">{{ 'MONITORING.LOADING_RECORDS' | translate }}</div>
  }

  @if (!loading && data.length === 0) {
    <div class="bg-white rounded-2xl p-6 text-sm text-gray-400">
      {{ 'MONITORING.NO_RECORDS_AVAILABLE' | translate }}
    </div>
  }

  @if (!loading && data.length > 0) {
    <div class="bg-white rounded-2xl p-4">
      <app-table
        [columns]="columns"
        [data]="data"
        
        [actions]="actions"
        [enablePagination]="true"
        [pageSize]="10"
        searchPlaceholder="MONITORING.SEARCH_CLIENTS"
      ></app-table>
    </div>
  }
</div>

<!-- MONITORING RECORDS POPUP -->
<app-popup
  [(show)]="showMonitoringPopup"
  [title]="monitoringPopupTitle"
  type="custom"
  width="w-full max-w-4xl min-w-[300px]"
  [showCustomFooter]="true"
  closeLabel="COMMON.CANCEL"
>
  @if (monitoringPopupLoading) {
    <div class="text-sm text-gray-500 py-6 text-center">{{ 'MONITORING.LOADING_RECORDS' | translate }}</div>
  }

  @if (!monitoringPopupLoading && monitoringPopupRecords.length === 0) {
    <div class="text-sm text-gray-400 py-6 text-center">{{ 'MONITORING.NO_RECORDS_FOUND' | translate }}</div>
  }

  @if (!monitoringPopupLoading && monitoringPopupRecords.length > 0) {
    <div class="overflow-x-auto">
      <table class="w-full text-sm border-collapse">
        <thead>
          <tr class="bg-[#1E2A78] text-white">
            <th class="border px-4 py-3">{{ 'MONITORING.VISIT_DATE' | translate }}</th>
            <th class="border px-4 py-3">{{ 'COMMON.DESCRIPTION' | translate }}</th>
            <th class="border px-4 py-3">{{ 'COMMON.REMARKS' | translate }}</th>
            <th class="border px-4 py-3">{{ 'COMMON.STATUS' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          @for (record of monitoringPopupRecords; track record.mntrngSeq) {
            <tr>
              <td class="border border-gray-300 px-4 py-3 text-gray-700">
                <span dir="ltr">{{ record.evntDt | date: 'dd-MMM-yyyy' }}</span>
              </td>
              <td class="border border-gray-300 px-4 py-3 text-gray-700">
                {{ record.dscrptn || '-' }}
              </td>
              <td class="border border-gray-300 px-4 py-3 text-gray-700">
                {{ record.rmrks || '-' }}
              </td>
              <td class="border border-gray-300 px-4 py-3 text-gray-700 text-end">
                {{ monitoringStatusLabel(record.stsKey) | translate }}
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  }
</app-popup>
